/*
 * @Author: hasee
 * @Date:   2016-12-12 18:27:29
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2019-05-27 10:42:58
 */
const env = location.host.split('.')[0].match(/(qc|box)\d?/g)
const spell = !!env ? (env.length > 0 ? `-${env[0]}` : '') : ''
const WXDOMAIN = `//wx${spell}.xinli001.com/`,

  CPDOMAIN = `//m-cpapi${spell}.xinli001.com/`,

  LXDOMAIN = spell?`//lingxi${spell}.xinli001.com/lingxi/service/`:`//m-lingxi${spell}.xinli001.com/lingxi/service/`,
  CPAPI = spell?`//cpapi${spell}.xinli001.com/cp/service/`:`//m-cpapi${spell}.xinli001.com/cp/service/`,
  LX = `//lx${spell}.xinli001.com/lx/`,
  FUN = `//qu${spell}.xinli001.com/lingxi/fun/`,
  YIAPIDOMAIN = `//yiapi${spell}.xinli001.com`,
  MDOMAIN = `//m${spell}.xinli001.com`,
  PGXINLI = `//appoint${(spell.indexOf('box') != -1) ? '-box1' : ((spell.indexOf('qc') != -1) ? '-qc4' : spell)}.pgxinli.com`,
  // MDOMAIN = `//m.xinli001.com`,
  // PGXINLI = `//appoint.pgxinli.com`,
  HCP = `//hcp${spell}.xinli001.com`,
  CPBADMIN = `//cpbadmin${spell}.xinli001.com`,
  LXKC = `//kc${spell}.xinli001.com/lingxikc/`,
  // LXKC = `//kc-box4.xinli001.com/lingxikc/`,
  APIS = {
    env: spell,
    host: `cp${spell}.japgb7.top`,
    shareHost: spell ? `static${spell}.xinli001.com` : `cp${spell}.japgb7.top`,
    shareHostC: `hd${spell}.xinli001.site`,
    shareHostA: `hd${spell}.ebejj12.top`,
    shareHostCC: `hd${spell}.xinli001.cc`,
    toutiaoShareHost:`hd${spell}.yixinli.xin`,//新增头条分享链接
    locationHerfType: false,
    //  灵犀接口
    wechatData: `${LXDOMAIN}wx/jsConfig`, //  微信初始化信息
    getUserInfo: `${LXDOMAIN}user/detail`, // 用户信息
    getUserInfoFromPlatfrom: `//m-cpapi${spell}.xinli001.com/cp/mservice/user/refreshUser`, // 从平台的userId换userKey
    getPlatformUserInfo: `//m-cpapi${spell}.xinli001.com/cp/mservice/platformUser/detail`, // 获取平台用户信息
    geWxAppUserInfo: `${LXDOMAIN}miniApp/user/detail`, // 小程序版的用户信息
    channelConfig: `${LXDOMAIN}getChannelMsg`, //  获取渠道配置
    homePageBanner: `${LXDOMAIN}getHomePageBannerData`, // 首页Banner
    getHotScales: `${LXDOMAIN}getHotScales`, // 首页最热测评
    getNewScales: `${LXDOMAIN}getNewScales`, // 首页最新测评
    getHandpickScales: `${LXDOMAIN}getHandpickScales`, // 获取 精选测评 接口
    getScales: `${LXDOMAIN}getScales`, // 获取测试列表
    getScaleDetail: `${LXDOMAIN}getScaleDetailIntro`, // 获取测试详情
    getNologinScaleDetail: `${LXDOMAIN}notLogin/getScaleDetailIntro`,// 获取免登录测试详情
    getAdvertisingCepingConfig: `${LXDOMAIN}notLogin/getAdvertisingCepingConfig`, // 获取先测试后付费测试配置
    fetchAdvertisingPlatform: `${LXDOMAIN}notLogin/getAdvertisingPlatform`, // 获取免登陆广告平台
    miniappScheme: `${LXDOMAIN}miniApp/miniappScheme`, // 获取小程序url scheme
    getRelevantScales: `${LXDOMAIN}getRelevantScales`, // 相关测试
    getRelevantScalesForReport: `${LXDOMAIN}getRelevantScalesForReport`,
    buyScale: `${LXDOMAIN}inner/buyScale`, // 购买测评
    notLoginBuyScale: `${LXDOMAIN}notLogin/buyScale`, // 免登购买测评
    reportPageCouponReceive: `${LXDOMAIN}coupon/reportPageCouponReceive`, // 个人报告页优惠券信息
    newUserCouponReceive: `${LXDOMAIN}coupon/newUserCouponReceive`, // 详情页新用户信息
    receiveCoupon: `${LXDOMAIN}coupon/receiveCoupon`, // 个人中心页新用户信息
    buyFunScale: `${LXDOMAIN}h5/order`, // 购买趣味测试
    buyScaleCallback: `${LXDOMAIN}pay/done/`, // 购买测评成功后的回调
    NotLoginbuyScaleCallback: `${LXDOMAIN}notLogin/payDone/`, // 购买测评成功后的回调
    getCategoryHotScales: `${LXDOMAIN}getCategoryHotScales`, // 大家都在测
    getMyData: `${LXDOMAIN}getMyScaleData`, // 我的测评
    searchOrder: `${LXDOMAIN}searchOrder`, // 查询订单状态接口
    noLoginSearchOrder: `${LXDOMAIN}notLogin/searchOrder`, // 查询未登录订单状态接口
    // 黑马合作项目，
    doFirst: `${LXDOMAIN}doFirst/buy`, // 在详情页调用，先做题后支付
    stopSignInAndBuy: `${LXDOMAIN}stopRegistration/buy`, // 提交完成后，先做题后支付

    // 评价相关
    reportShowComment: `${LXDOMAIN}getWhetherEvaluateInfo`, // 报告页显示是否存在评论，决定是看评价还是发评价
    publishComment: `${LXDOMAIN}publishEvaluation`, // 提交评价
    deleteComment: `${LXDOMAIN}deleteEvaluation`, // 删除评价
    getMyComment: `${LXDOMAIN}getMyEvaluation`, // 获取我的评价
    getUnCommentScales: `${LXDOMAIN}getAwaitEvaluateScalePools`, // 未评价测评
    getHandpickComments: `${LXDOMAIN}getHandpickEvaluations`, // 获取精选评价
    getLatestComments: `${LXDOMAIN}getNewestEvaluations`, // 获取最新评价
    getDetailPageComments: `${LXDOMAIN}getDetailPageEvaluationData`, // 获取最新评价
    allComment: `${LXDOMAIN}getAllEvaluations`, //获取所有评价

    // 赠送功能相关的接口
    gift_buy: `${LXDOMAIN}gift/buyScale`, // 购买赠送的测评
    gift_mine_give: `${LXDOMAIN}gift/giftsToScales`, //  赠送管理 - 我送出的测评
    gift_mine_receive: `${LXDOMAIN}gift/receiveScales`, // 赠送管理 - 我收到的赠送测评
    gift_give: `${LXDOMAIN}gift/giftsTo`, // 赠送测评，分享出去后调用
    gift_receive_detail: `${LXDOMAIN}gift/receiveDetail`, // 领取页详情
    gift_receive: `${LXDOMAIN}gift/receive`, // 领取测评

    // 灵犀的套餐
    /* 套餐组合 */
    getComboDetail: `${LXDOMAIN}getComboDetail`, // 获取单条套餐详情
    buyCombo: `${LXDOMAIN}inner/buyCombo`, //  测评组合套餐购买接口
    // lxReportCombo: `//lingxi${spell}.xinli001.com/lingxi/service/getComboRemainScales`, // 小小包麻麻专用 - 测评报告页获取套餐其他测评
    getComboList: `${LXDOMAIN}getComboRemainScales`, // 获取 套餐包含的测评接口 和 报告页获取套餐的其他测评

    // 趣味测试的接口
    h5Detail: `${LXDOMAIN}h5/detail`,

    // 搜索相关接口
    searchRecommend: `${LXDOMAIN}search/recommendAndHot`, // GET, no params, 热搜推荐
    searchAssociation: `${LXDOMAIN}search/association`, // GET, params: [keyword], 搜索联想
    search: `${LXDOMAIN}search`, // GET, params: [channelId, keyword], 获取搜索结果
    funSearch: `${FUN}search`, // GET, params: [channelId, keyword], 获取搜索结果

    /* 测评系统 模块Api */
    testChoicegender: `${CPDOMAIN}updateEmployeeGender`, // 选择性别
    testIntro: `${CPDOMAIN}getQuestionnaireIntro`, // 测试介绍
    answerOption: `${CPDOMAIN}getEmployeeTestQuestions`, // 获取题目选项
    commitAnswer: `${CPDOMAIN}commitStepAnswers`, // 提交答案
    commmitAllAnswer: `${CPDOMAIN}commitAllAnswers`, // 提交全部报告
    viewReport: `${CPDOMAIN}viewTestReport`, // 查看报告
    getReportRecomendTest: `${WXDOMAIN}staticApi/external/getMoreTest`, // 查看报告页获取推荐测评
    clearAnswer: `${CPDOMAIN}clearStepAnswers`, // 清除答案
    shareCpReport: `//cp${spell}.xinli001.com/reportShare/isReportShareExist`, // 分享报告
    viewTestReport: `http://lingxi-box3.xinli001.com/lingxi/service/viewTestReport`,
    getScl90Report: `${CPAPI}report/getScl90Report`,// 获取Scl90定制报告

    viewReport2: `${CPAPI}viewReport`,
    viewAlgorithmReport: `${CPAPI}viewAlgorithmReport`, //查看多算法报告接口
    scaleModulesMsg: `${CPAPI}report/getScaleModulesMsg`,

    toGeneralReport: `${CPAPI}toGeneralReport`, //新增报告页聚合页

    // 旧测评系统接口
    cp: {
      intro: `${CPDOMAIN}getQuestionnaireIntro`, // 测试介绍
      setGender: `${CPDOMAIN}updateEmployeeGender`, // 选择性别
      questions: `${CPDOMAIN}getEmployeeTestQuestions`, // 获取题目选项
      commitStep: `${CPDOMAIN}commitStepAnswers`, // 提交答案
      commitClear: `${CPDOMAIN}clearStepAnswers`, // 清除答案
      commitAll: `${CPDOMAIN}commitAllAnswers` // 提交全部报告
    },
    /* 新版做题接口，接入的是壹心理CP系统的接口 */
    yxlCp: {
      logIn: `${CPDOMAIN}cp/service/login`, // 登录新测评系统
      intro: `${CPDOMAIN}cp/service/getScaleIntro`, // 获取测评介绍
      curModuleintro: `${CPDOMAIN}cp/service/getCurModuleIntro`, // 获取测评介绍
      setGender: `${CPDOMAIN}cp/service/updateUserGender`, // 选择性别
      questions: `${CPDOMAIN}cp/service/getUserModuleQuestions`, //获取题目
      commitStep: `${CPDOMAIN}cp/service/commitStepAnswers`, // 异步提交
      commitClear: `${CPDOMAIN}cp/service/clearStepAnswers`, // 重做清空已选
      commitAll: `${CPDOMAIN}cp/service/commitAllAnswers` // 全部提交
    },
    // 内隐自尊测试
    implicit: {
      questions: `${CPDOMAIN}cp/service/nyzz/getUserModuleQuestions`, //获取题目
      commitStep: `${CPDOMAIN}cp/service/nyzz/commitStepAnswers`, // 异步提交
      commitClear: `${CPDOMAIN}cp/service/nyzz/clearStepAnswers`, // 重做清空部分提交记录
      commitAll: `${CPDOMAIN}cp/service/nyzz/commitAllAnswers` // 全部提交
    },

    // 报告页分享 模块的接口
    shareDetail: `${CPDOMAIN}getShareReportData`,
    shareRecommend_wx: `${WXDOMAIN}www/Share/getMoreTest`,
    shareRecommend_m: `//m${spell}.xinli001.com/ceshi/get-more-test.json`,
    //   我也要测的地址
    getDetailUrl: `${LXDOMAIN}getDetailUrl`,
    vote: `${CPDOMAIN}vote`, // 分享页投票项地址
    getWeixinIimgCode: `${CPDOMAIN}cp/service/getImg`, // 分享页投票项地址

    getQuestionnaire: `${LX}cp//questionnaire/getQuestionnaire`, //获取ui主题风格

    // 收藏接口
    collectScale: `${LXDOMAIN}collect/collectScale`, // 详情页收藏接口
    getCollectScaleData: `${LXDOMAIN}collect/getCollectScaleData`, // 我的测评--收藏列表接口
    getTrackScaleData: `${LXDOMAIN}track/getTrackScaleData`, // 我的测评--收藏列表接口
    delTrackScale: `${LXDOMAIN}track/delTrackScale`, // 我的测评--足迹列表(删除足迹)

    getCustomConfig: `${CPAPI}getCustomConfig`, // 心声页面 --- 获取自定义分享配置
    getResultVoiceArr: `${CPAPI}getResultVoiceArr`, // 心声页面 --- 获取自定义分享配置
    longToShort: `${LXDOMAIN}longToShort`, // 心声页面 --- 二维码长连接转短链接
    shortToLong: `${LXDOMAIN}shortToLong`, // 心声页面 --- 二维码短连接转长链接
    shareAuth: `${LXDOMAIN}share/auth`, // 心声落地页重定向接口

    //双十一促销落地页
    showExtrance: `${LXDOMAIN}package/showExtrance`, // 首页入口展示
    showDeposit: `${LXDOMAIN}package/showDeposit`, // 定金礼包的展示
    getDepositOrder: `${LXDOMAIN}package/getDepositOrder`, // 我的礼包的展示
    packageList: `${LXDOMAIN}package/list`, // 获取礼包列表
    packageBuy: `${LXDOMAIN}package/buy`, // 购买礼包
    getMyPackageOrderList: `${LXDOMAIN}getMyPackageOrderList`, // 获取我的礼包

    //双十一促销我的手收藏券
    userCouponList: `${LXDOMAIN}coupon/userCouponList`, // 获取个人中心优惠券列表（未使用、已使用、已失效）、下单购买页面优惠券列表
    getCustomCoupon: `${LXDOMAIN}coupon/getCustomCoupon`, // 单击共享券赠送按钮获取优惠券的详情
    couponGiftReceive: `${LXDOMAIN}coupon/couponGiftReceive`, // 好友点击领取共享券

    //双十一分销
    countMyCoupon: `${LXDOMAIN}coupon/countMyCoupon`, //我的优惠券 数量查询接口
    //兑换单品券
    redeemCodeUse: `${LXDOMAIN}redeemCode/use`, //我的优惠券 兑换优惠券
    //双十二活动
    getDoubleTwelveScales: `${LXDOMAIN}getDoubleTwelveScales`, //双十二活动测评列表
    couponDoubleTwelveStatus: `${LXDOMAIN}coupon/getDoubleTwelveStatus`, //双十二活动优惠券领取资格
    doubleTwelveScalesReceive: `${LXDOMAIN}coupon/receive`, //领取自定义优惠券
    scalePoolCouponList: `${LXDOMAIN}coupon/scalePoolCouponList`, //下单购买页面优惠券列表
    newUserVerify: `${LXDOMAIN}newUser/verify`, //双十二活动入口展示
    newUserPopWindows: `${LXDOMAIN}newUser/popWindows`, //双十二活动入口弹窗
    //报告页pdf（https://code.aliyun.com/yixinli/lingxi/blob/cbfb91d2652a010cfab66b786d1ddcc6f2d87eb3/core/document/%E6%8A%A5%E5%91%8A%E8%BF%81%E7%A7%BB%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3.md）
    getPdfStatus: `${LXDOMAIN}getPdfStatus`, //获取报告迁移服务订单状态
    buyPdf: `${LXDOMAIN}buyPdf`, //购买报告迁移服务
    sendMailWithPdf: `${CPAPI}sendMailWithPdf`, //购买报告pdf发送邮箱
    sendMailWithPdfNew: `${HCP}/common/sendMailWithPdf`, //购买报告pdf发送邮箱(新)
    deleteReport: `${LXDOMAIN}deleteReport`, //购买报告迁移服务
    //添加限时优惠券(https://code.aliyun.com/yixinli/lingxi/blob/ab83daec3a85b2cac5b3b8288e383f8dfb449501/core/document/%E6%B5%8B%E8%AF%84%E7%A4%BC%E5%8C%85%E4%BC%98%E6%83%A0%E5%88%B8%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3.md)
    getDiscountCouponStatus: `${LXDOMAIN}timeLimit/getDiscountCouponStatus`, //限时折扣优惠券弹窗状态资格
    discountCouponReceive: `${LXDOMAIN}timeLimit/discountCouponReceive`, //限时折扣优惠券领取
    getUserOscarActCard: `${LXDOMAIN}getUserOscarActCard`, //获取用户奥斯卡卡片记录的接口
    // 报告导咨询接口(https://code.aliyun.com/yixinli/lingxi/blob/9978046012c4cd3f090a5cbc4b02c130c26a0408/core/document/%E6%8A%A5%E5%91%8A%E5%AF%BC%E5%92%A8%E8%AF%A2%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3.md)
    // 判断报告导咨询价格接口
    verifyConsultPrice: `${LXDOMAIN}reportToConsult/verifyConsultPrice`, //判断报告导咨询价格接口
    buyConsult: `${LXDOMAIN}reportToConsult/buyConsult`, //购买报告导咨询服务接口
    submitConsultForm: `${LXDOMAIN}reportToConsult/submitConsultForm`, //确认提交咨询表单接口
    getMyConsultOrderData: `${LXDOMAIN}consult/listOrders`, //获取我的咨询订单接口
    getNotLoginConsultOrderData: `${LXDOMAIN}notLogin/listConsultOrders`, // 获取免登咨询订单接口
    getReportConsultForm: `${LXDOMAIN}reportToConsult/getReportConsultForm`, //获取单个咨询表单详情接口
    verifyConsultFormRedDot: `${LXDOMAIN}reportToConsult/verifyConsultFormRedDot`, //咨询订单是否有待确认红点接口
    setTop20PushRelation: `${LXDOMAIN}setTop20PushRelation`, //精准top20推送
    checkBindMobile: `${LXDOMAIN}consult/checkBindMobile`, //判断用户是否绑定了手机号
    notLoginCheckBindMobile: `${LXDOMAIN}notLogin/checkBindMobile`, // 免登检查此刻手机号绑定状态
    getConsultToken: `${LXDOMAIN}consult/getToken`, // 获取咨询token
    consultSendValidcode: `${LXDOMAIN}consult/sendValidcode`, //平台发送短信验证吗
    consultBindUserMobile: `${LXDOMAIN}consult/bindUserMobile`, //平台绑定用户手机号码
    notLoginconsultBindUserMobile: `${LXDOMAIN}notLogin/bindPhone`, // 免登检查此刻手机号
    syncByUserKey: `${LXDOMAIN}consult/syncByUserKey`, // 测评导此刻订单同步在此刻咨询创建订单
    syncByOrder: `${LXDOMAIN}notLogin/syncByOrder`, // 免登录-测评导此刻订单同步在此刻咨询创建订单
    syncByOrderNo: `${LXDOMAIN}consult/syncByOrderNo`, // 订单同步
      // 投放导此刻
    notLoginGetCpPhone: `${LXDOMAIN}notLogin/getCepingPhone`,  // 免登录获取手机号

    // vip 高端产品
    getHighEndIndexScales: `${LXDOMAIN}highEnd/getHighEndIndexScales`, //首页获取测评列表接口
    getHighEndScaleDetailIntro: `${LXDOMAIN}highEnd/getHighEndScaleDetailIntro`, //获取高端产品单条测评的详情接口
    getHighEndMyScaleData: `${LXDOMAIN}highEnd/getHighEndMyScaleData`, //获取 我的测评列表 (已购买的套餐和测评数据) 接口
    getDistributionCard: `${LXDOMAIN}distribution/getDistributionCard`, //获取分销卡接口
    getMyReward: `${LXDOMAIN}distribution/getMyReward`, //  获取我的分销收益接口
    viewHighEndReport: `${CPAPI}viewHighEndReport`, //查看高端测评报告
    getReportDataUrl: `${LXDOMAIN}getReportDataUrl`, //查看高端报告复制链接
    //趣味测试接口
    fungetDetail: `${FUN}getDetail`, //趣味测试详情接口
    funquestion: `${FUN}getQuestionsOptions`, //趣味测试
    funsendAnswer: `${FUN}postFunOptions`, //提交测试
    fungetResult: `${FUN}getFunResult`, //趣味测试结果
    getWechatFunDetailRecommends: `${FUN}getWechatFunDetailRecommends`, // 趣味测试推荐
    getDailyFunTest: `${FUN}getDailyFunTest`, // 趣味测试首页每日一测
    getDailyFunTestList: `${FUN}getDailyFunTestList`, //趣味测试分类页每日一测列表
    funScales: `${FUN}funScales`, // 趣味测试
    getFunScaleDetailList: `${LXDOMAIN}getFunScaleDetailList`, //趣味测试简介列表
    setFavoriteFunScale: `${FUN}setFavoriteFunScale`, //测试结果页喜欢
    getFavoriteMessage: `${FUN}getFavoriteMessage`, //测试结果页获取喜欢信息
    getWechatFunResultRecommends: `${FUN}getWechatFunResultRecommends`, //微站测试结果页相关推荐
    getMyFavoriteFunScaleList: `${FUN}getMyFavoriteFunScaleList`, // 我喜欢的趣味测试列表
    storeSource: `${LXDOMAIN}storeSource`, //全局添加跟踪标识接口
    closeConsultModule: `${LXDOMAIN}reportToConsult/closeConsultModule`, //关闭咨询师解读模块展示
    getConsultModuleStatus: `${LXDOMAIN}reportToConsult/getConsultModuleStatus`, //获取咨询师解读模块展示状态

    getMyEvaluationList: `${LXDOMAIN}getAwaitEvaluateScalePools`, //我的评价列表
    getPersonalStats: `${LXDOMAIN}getPersonalStats`, //我的展示页数据

    // 新增高价测试接口
    getProfessionalScales: `${LXDOMAIN}getProfessionalScales`, // 获取高价测试列表
    viewProfessionalReport: `${CPAPI}viewProfessionalReport`, //查看高价测评报告
    //盘古登录
    bindGenesis: `${LXDOMAIN}bindGenesis`, //盘古登录

    //会员接口
    getVipInfo: `${LXDOMAIN}vip/getVipInfo`, // 获取会员信息
    getVipHomePageInfo: `${LXDOMAIN}vip/getVipHomePageInfo`, // 双12会员活动首页接口
    vipDistributionRankingList: `${LXDOMAIN}vip/vipDistributionRankingList`, // 会员分销排行榜
    vipBuy: `${LXDOMAIN}vip/buy`, // 购买会员礼包

    receiveVipCoupon: `${LXDOMAIN}vip/receiveVipCoupon`, // 领取会员红包
    vipCouponList: `${LXDOMAIN}vip/vipCouponList`, // 会员红包领取列表
    vipPopWindow: `${LXDOMAIN}vip/vipPopWindow`, //  会员弹窗接口
    vipGetUrl: `${LXDOMAIN}vip/getUrl`, //  会员页跳转接口
    authVipDistribution: `${LXDOMAIN}vip/authVipDistribution`, //  会员页跳转接口
    authVipRights: `${LXDOMAIN}vip/authVipRights`, //  权益页跳转接口
    getVipDistributionCard: `${LXDOMAIN}vip/getVipDistributionCard`, //  获取会员分销卡地址
    appCheckIn: `${YIAPIDOMAIN}/v6/yi/integral/save-task.json`, // 平台app6.6积分接口，在APP内才触发
    getConfigureByCode: `https://yiapp${spell}.xinli001.com/commonConfigure/getConfigureByCode`,
    // 修改抖音答题页 接口路由
    touTiaoMiniAppCommitAnswer: `${CPAPI}touTiaoMiniApp/commitStepAnswers`, // 提交答案
    touTiaoMiniAppCommmitAllAnswer: `${CPAPI}touTiaoMiniApp/commitAllAnswers`, // 提交全部报告
    touTiaoMiniAppViewReport2: `${CPAPI}touTiaoMiniApp/viewReport`,
    touTiaoMiniAppViewAlgorithmReport: `${CPAPI}touTiaoMiniApp/viewAlgorithmReport`, //查看多算法报告接口

    meditatingPop: `${LXDOMAIN}touTiaoMiniApp/meditatingPop`, // 查询是否需要弹窗
    closeMeditatingPop: `${LXDOMAIN}touTiaoMiniApp/colseMeditatingPop`,// 关闭弹窗
    // 525 心理健康活动
    get360DistributionCard: `${LXDOMAIN}distribution/get360DistributionCard`, //  获取525 360心理健康体检分销卡地址
    distributionRankingList: `${LXDOMAIN}distribution/distributionRankingList`, //  个人分销排行榜
    get525Qrcode: `${LXDOMAIN}inner/getQrcode`,  //  报告页公众号二维码

    getConsultReadingReportTeachers: `${MDOMAIN}/consultteacher/ceping_diversion`,
    cpWebAppPlayer:  `${MDOMAIN}/cpWebApp-player`, // 抖音小程序webview课程播放页Url
    // 抑郁单品
    getDepressedUserList: `${LXDOMAIN}depressed/getDepressedUserList`, // 获取抑郁单品最新购买用户列表
    depressedPackages: `${LXDOMAIN}depressed/depressedPackages`, // 抑郁重复测评礼包价格列表
    consultDepressedPackages: `${LXDOMAIN}consult/depressedPackages`, // 抑郁重复测评礼包价格列表
    buyDepressedPackage: `${LXDOMAIN}depressed/buyDepressedPackage`, // 购买抑郁单品
    depressedPayDone: `${LXDOMAIN}depressed/pay/done/`, // 抑郁单品支付完的回调
    cpConsultantCpDiversion: `${PGXINLI}/cpConsultant/cpDiversion`, // 获取报告关联的咨询师
    uploadBase64Img: `${LXDOMAIN}uploadBase64Img`, // 图片上传
    uploadImg: `${LXDOMAIN}uploadImg`,
    shareDataToCommunity: `${LXDOMAIN}shareDataToCommunity`, // 分享报告到社区
    repeatTest: `${LXDOMAIN}depressed/repeatTest/`, // 抑郁重复测评-再测一次

    newUserGiftPopWindow: `${LXDOMAIN}newUserGiftPopWindow`, // 查询B站先测试后付费报告页查询弹窗状态
    receiveNewUserGift: `${LXDOMAIN}receiveNewUserGift`, // 存储B站先测试后付费报告页查询弹窗状态
    //房树人需求
    fsrGetUserModuleQuestions: `${CPDOMAIN}cp/service/fsr/getUserModuleQuestions`, //frs获取全部问题
    fsrGetUserModuleQuestionsV2: `${CPDOMAIN}cp/service/fsr/v2/getUserModuleQuestions`, //frs获取全部问题(新房树人-绘图版本)
    fsrCommitImageAnswers: `${CPDOMAIN}cp/service/fsr/v2/commitImageAnswers`, //frs图片题答案提交(新房树人-绘图版本)
    fsrCommitAll: `${CPDOMAIN}cp/service/fsr/commitAllAnswers`, // 房树人提交全部答案
    fsrFetchImage: `${HCP}/fsr/fetchImage`, //获取已上传的房树人测评图片
    //雨中人需求
    yzrGetUserModuleQuestions: `${CPDOMAIN}cp/service/yzr/getUserModuleQuestions`, // yzr获取全部问题
    yzrFetchImage: `${HCP}/common/getImageByAccountId`, //获取已上传的雨中人测评图片

    sendValidcode: `${CPBADMIN}/cp/bus/businessScaleAllocation/sendValidcode`, // 发送登录手机验证码
    getAllocationScaleAddr: `${CPBADMIN}/cp/bus/businessScaleAllocation/getAllocationScaleAddr`,
    scaleAddrByAccount: `${CPBADMIN}/cp/bus/businessScaleAllocation/scaleAddrByAccount`,  // 账号密码登录获取答题地址
    getScaleInfo: `${CPBADMIN}/client/getScaleInfo`,
    getBaseInfo: `${CPBADMIN}/client/getBaseInfo`,
    applyAssign: `${CPBADMIN}/client/apply`, // 申请分配测评
    getApplyStatus: `${CPBADMIN}/client/getApplyStatus`, // 申请分配状态查询
    // 报告页分享图片
    getCommonDistributionCard: `${LXDOMAIN}distribution/getCommonDistributionCard`, // 获取报告页分享图片

    // 2020 双十一活动
    buyDoubleElevenScales: `${LXDOMAIN}doubleEleven/buyDoubleElevenScales`, // 购买活动测评
    doubleElevenPayDone: `${LXDOMAIN}doubleEleven/payDone/`, // 活动测评支付完的回调

    // 获取广告&浮标信息
    fetchAdsense: `${HCP}/adsense/fetchAdsense`, //获取已上传的房树人测评图片

    // 大众课抖音测评小程序
    getLesson: `${LXDOMAIN}touTiaoMiniApp/getLesson`, //测评报告页-获取推荐课程
    getAppHeartCoach: `${LXDOMAIN}heartCoach/getPsychicCoachs`,

    // 导咨询接口
    fetchGuideData: `${HCP}/gmc/fetchGuideData`, // 获取报告页测评导咨询文案信息
    fetchAppConsultantInfo: `${HCP}/appConsult/fetchConsultantInfos`, // 获取 app 详情页测评咨询师信息
    fetchAppGuideData: `${HCP}/appConsult/fetchGuideData`, // 获取 app 报告页咨询文案信息
    buyCikeConsult: `${LXDOMAIN}consult/buyConsult`, //  购买此刻咨询支付
    notLoginBuyCikeConsult: `${LXDOMAIN}notLogin/buyConsult`, //  购买此刻咨询支付
    cikePayDone: `${LXDOMAIN}consult/payDone`, // 购买此刻咨询回调
    fetchConsultantInfos: `${HCP}/gmc/fetchConsultantInfos`, // 获取测评咨询师展示信息
    fetchConsultPrices: `${HCP}/gmc/fetchConsultPrices`, // 获取详情页和报告页咨询价格信息
    buyConsultCombo: `${LXDOMAIN}consult/buyConsultCombo`, // 详情页咨询师购买套餐
    getConsultDescription: `${HCP}/gmc/getConsultDescription`, // 获取此刻咨询描述信息
    getTeacherAndPrice: `${HCP}/gmc/getTeacherAndPrice`, // 获取此刻咨询老师及价格配置信息
    getCompleteStatus: `${LXDOMAIN}consult/getCompleteStatus`, // 获取此刻咨询订单完成情况
    receiveGuideCoupon: `${HCP}/appConsult/receiveCoupon`, // 领取导流咨询五折券

    sendMail: `${CPDOMAIN}cp/service/sendMail`, // 发送报告到邮箱
    // 2021-525活动
    activity525Countdown: `${LXDOMAIN}activity525/countdown`, // 倒计时
    activity525OrderMakeUp: `${LXDOMAIN}activity525/orderMakeUp`, // 凑单测评列表
    activity525BuyConsultCombo: `${LXDOMAIN}activity525/buyConsultCombo`, // 组合测评购买
    activity525FreeConsultStatus: `${LXDOMAIN}activity525/freeConsultStatus`, // 525活动免费咨询购买状态、使用状态、倒计时
    activity525BuyJudge: `${LXDOMAIN}activity525/buyJudge`, // 判断是否是首单

    // 活动卡相关
    scaleList: `${LXDOMAIN}scaleList`,// 查询指定测评列表
    activityCardList: `${LXDOMAIN}activityCard/activityCardList`,// 获取活动卡信息列表
    activityCardInfo: `${LXDOMAIN}activityCard/activityCardInfo`,// 根据订单号查询活动卡信息
    activityCardRecords: `${LXDOMAIN}activityCard/records`,// 活动卡免费权益使用记录列表
    listActivityCardOrder: `${LXDOMAIN}notLogin/listActivityCardOrder`, // 获取活动卡订单信息

    // 导此刻优化
    getRecentConsultUser: `${HCP}/gmc/getRecentConsultUser`, // 获取最近咨询用户

    consultStatus: `${LXDOMAIN}consult/consultStatus`, // 获取此刻咨询状态

    notCompleteCount: `${LXDOMAIN}consult/notCompleteCount`, // 未完成订单数
    getTeacherById: `${HCP}/gmc/getTeacher`, // 通过咨询师id获取咨询师信息
    h5activityAuth: `${LXDOMAIN}h5activity/auth`, // 授权
    h5activityUseStatus: `${HCP}/h5activity/useStatus`, // h5裂变活动1元购测评机会使用状态

    // 匹配测评
    matchTestBuy: `${LXDOMAIN}matchTest/buy`, // 付费购买匹配测试
    matchTestCreateOrder: `${LXDOMAIN}matchTest/doFirstAfterBuy/createOrder`, // 先测试后付费--下单
    matchTestPayOrder: `${LXDOMAIN}matchTest/doFirstAfterBuy/payOrder`,// 先测试后付费--付费
    matchTestToReport: `${LXDOMAIN}matchTest/toReport`, // 跳转答题页、报告页
    matchEntrance: `${HCP}/match/entrance`, // 匹配测试入口显示
    matchList: `${HCP}/match/list`, // 匹配测试匹配榜
    matchPoster: `${HCP}/match/poster`, // 匹配测试邀请海报
    matchFactor: `${HCP}/match/factor`, // 性格测试匹配结果维度集合

    getSubscribeYet: `${LXDOMAIN}MentalCognitiveMap/getSubscribeYet`, // 用户是否关注了公众号

    // 2022会员
    getNewCePingReport: `${LXDOMAIN}getNewCePingReport`, // 获取报告、咨询最新信息
    startLottery: `${LXDOMAIN}vip/v3/startLottery`, // 开始抽奖
    getLotteryStatus: `${LXDOMAIN}vip/v3/getLotteryStatus`, // 获取是否已抽奖
    getMyRewardRecord: `${LXDOMAIN}vip/v3/getMyRewardRecord`, // 获取抽奖记录
    submitInformation: `${LXDOMAIN}vip/v3/submitInformation`, // 提交领奖信息
    vip3Buy: `${LXKC}api/buyCpVip`, // 购买会员 3.0
    kcVip: `${LXKC}user/api/vip`, // 课程分销数据
    getVip3HomePageInfo: `${LXDOMAIN}vip/v3/getVipHomePageInfo`, // 会员详情页接口
    receiveUnionVip: `${LXDOMAIN}vip/v3/receiveUnionVip`, // 领取联合会员
    getUnionVipStatus: `${LXDOMAIN}vip/v3/getUnionVipStatus`, // 联合会员领取状态

    // 2023会员
    getVip4HomePageInfo: `${LXDOMAIN}vip/v4/getVipHomePageInfo`, // 会员详情页接口


    // 儿童绘画
    beforeAndAfterViewReport: `${CPDOMAIN}cp/service/lesson/beforeAndAfter/viewReport`, // 前后测报告页
    midViewReport: `${CPDOMAIN}cp/service/lesson/mid/viewReport`, // 中间测报告页数据
    getReportProposal: `${CPBADMIN}/bus/businessUserLesson/getReportProposal`, // 获取特色课程老师意见
    updateReportProposal: `${CPBADMIN}/bus/businessUserLesson/updateReportProposal`, // 修改特色课程老师意见
    getPictureUrl: `${CPBADMIN}/bus/businessUserLesson/getPictureUrl`, // 获取用户作品图片
    childCommitAll: `${CPDOMAIN}cp/service/lesson/beforeAndAfter/commitAllAnswers`, // 前后测提交全部答案
    childMidQuestions: `${CPDOMAIN}cp/service/lesson/mid/getUserModuleQuestions`, // 中间测获取所有问题
    childMidCommitAll: `${CPDOMAIN}cp/service/lesson/mid/commitAllAnswers`, // 中间测获取所有问题
    childGetPictureUrl: `${CPBADMIN}/bus/businessUserLesson/getPictureUrl`, // 获取特色课程老师意见

    getDistributionBackground: `${HCP}/common/getDistributionBackground`, // 根据测评id获取分销海报
    // 此刻邀请有礼2.0
    cpConsultantOpenInvitee: `${PGXINLI}/consultUserCpRecord/openInvitee`, // 获取相关浮窗信息

    getAnswerRecord: `${CPBADMIN}/client/getAnswerRecord`, // 获取答题情况

    // 投放导倾诉
    qingsuCreateOrder: `${LXDOMAIN}qingsu/createOrder`,
    getLaunchChannelInfo: `${MDOMAIN}/applet/get-short-url.json`,

    getCpReportResult: `${CPDOMAIN}cp/service/inner/getCpReportResult`, // 抑郁测评结果查询

    getSingleSignOnUrl: `${LXDOMAIN}platform/getSingleSignOnUrl`, // 我的测评-查看咨询获取免登录地址

    getAuth: `${LXDOMAIN}yixinli/consultQrCode/auth`, // 二维码-授权接口

    // 邀请有礼
    invitePageData: `${LXDOMAIN}vip/v4/invitePageData`,
    inviteHelp: `${LXDOMAIN}vip/v4/inviteHelp`,

    // 我的心理画像
    getUserProfile: `${CPAPI}getUserProfile`,

    checkOrderPush: `${HCP}/common/checkOrderPush`, // 检查订单号上报情况（前端js布玛数据回传中使用，限制一个订单号只能上报一次）
    autoDoQuestions: `${CPAPI}inner/autoDoQuestions`, // 随机自动答题（测试环境使用）
  }

export default APIS



// WEBPACK FOOTER //
// ./src/apis.js